//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/general-ledger/reconcile/adjustment';

export default {
    data: function data() {
        return {
            adjustment_date: moment().format('MM/DD/YYYY'),
            method: 'add',
            amount: 0,
            description: '',
            bankReconcileID: null,
            config: {
                maxDate: moment().format('MM/DD/YYYY')
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('add-manual-bank-reconcile-adjustment', function (id) {
            _this.bankReconcileID = id;
            $el.$children[0].$data.showSmallModal = true;
        });
    },


    methods: {
        save: function save() {
            var _this2 = this;

            this.amount = Math.abs(this.amount);

            var payload = {
                adjustment_date: this.adjustment_date,
                method: this.method,
                amount: this.amount,
                description: this.description,
                bankReconcileID: this.bankReconcileID
            };

            axios.post(BASE_URL + '/store', payload).then(function (response) {
                Event.$emit('refresh-data', true);
                _this2.$children[0].$data.showSmallModal = false;
            });
        },
        close: function close() {
            this.$children[0].$data.showSmallModal = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reconcile/AddAdjustment.vue
// module id = HHsh
// module chunks = 0 1